import '../../../TrackmanEvents/EventTile/EventTile.scss';

import { ReactComponent as ArrowUpIcon } from 'images/icons/ArrowUp.svg';
import { ReactComponent as CrownIcon } from 'images/icons/Crown.svg';
import ImageDragAndDropUploader from 'components/Admin/EventSettings/ImageDragAndDropUploader/ImageDragAndDropUploader';
import VideoThumbnail from 'components/VideoThumbnail/VideoThumbnail';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import dayjs from 'dayjs';
import { formatTimeLength } from 'utilities/formatDate';
import { observer } from 'mobx-react-lite';
import timezone from 'dayjs/plugin/timezone';
import { useCallback } from 'react';
import { useStores } from 'index';
import { useTranslation } from 'react-i18next';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advancedFormat);

export const EventPreview = observer(() => {
  const es = useStores().trackmanEventsEditorStore;
  const { t } = useTranslation();

  const timeInfo = es.eventItem.startDate
    ? !es.eventItem.recordingReady
      ? dayjs(es.eventItem.startDate).tz(dayjs.tz.guess()).format('MMM DD, h:mma z')
      : `Streamed ${dayjs().diff(dayjs(es.eventItem.startDate), 'days')} day(s) ago`
    : '[MMM DD, HH:mma]';

  const renderLocationInfo = useCallback(() => {
    if (es.eventItem.recordingReady) return null;
    if (es.eventItem.locationType === 'Online') return <h3>Online</h3>;
    if (es.eventItem.location) return <h3>{es.eventItem.location}</h3>;
    return null;
  }, [es.eventItem]);

  return (
    <div className='admin-edit-section event-tile'>
      <h2>Preview</h2>
      {es.eventItem.videoId ? (
        <VideoThumbnail
          video={es.eventItem.videoId}
          thumbnailSize='hqdefault'
          badgeText={es.eventItem.premiumEvent ? t('Premium', { ns: 'trackmanEvents' }) : ''}
          badgeIcon={es.eventItem.premiumEvent ? <CrownIcon /> : null}
        />
      ) : (
        <ImageDragAndDropUploader
          badgeText={es.eventItem.premiumEvent ? t('Premium', { ns: 'trackmanEvents' }) : ''}
          badgeIcon={es.eventItem.premiumEvent ? <CrownIcon /> : null}
        />
      )}
      <div className='event-info'>
        {renderLocationInfo()}
        <div className='time'>
          <span>
            {timeInfo} - {es.eventItem.premiumEvent ? 'Paid' : 'Free'}
          </span>
          {es.eventItem.videoLength ? <span className='video-length'>{formatTimeLength(es.eventItem.videoLength)}</span> : null}
        </div>
        <div className='event-title'>
          {es.eventItem.title !== '' ? es.eventItem.title : '[Event Title Event Title Event Title]'}
          <ArrowUpIcon />
        </div>
      </div>
    </div>
  );
});

export default EventPreview;
